import {
  CREATE_COUPON,
  CREATE_COUPON_SUCCESS,
  DELETE_COUPON,
  GET_ALL_COUPON_LIST,
  GET_ALL_COUPON_LIST_SUCCESS,
  GET_COUPON_BY_ID,
  GET_COUPON_BY_ID_SUCCESS,
  GET_COUPON_HISTORY,
  GET_COUPON_HISTORY_SUCCESS,
  UPDATE_COUPON,
  UPDATE_COUPON_SUCCESS,
} from '../storeTypes';

const INIT_STATE = {
  loader: false,
  couponList: [],
  couponDetails: null,
  couponHistory: [],
  totalCount: 0
};

function CouponReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case GET_ALL_COUPON_LIST: {
      return {
        ...state,
        couponList: [],
        loader: true,
      };
    }

    case GET_ALL_COUPON_LIST_SUCCESS: {
      return {
        ...state,
        loader: false,
        couponList: action.payload,
      };
    }

    case CREATE_COUPON: {
      return {
        ...state,
        loader: true,
      };
    }
    case CREATE_COUPON_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }
    case UPDATE_COUPON: {
      return {
        ...state,
        loader: true,
      };
    }
    case UPDATE_COUPON_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }
    case GET_COUPON_BY_ID: {
      return {
        ...state,
        couponDetails: null,
        loader: true,
      };
    }
    case GET_COUPON_BY_ID_SUCCESS: {
      return {
        ...state,
        loader: false,
        couponDetails: action.payload,
      };
    }
    case GET_COUPON_HISTORY: {
      return {
        ...state,
        couponHistory: [],
        loader: true,
      };
    }
    case GET_COUPON_HISTORY_SUCCESS: {
      return {
        ...state,
        loader: false,
        couponHistory: action.payload.data,
        totalCount: action.payload.total,
      };
    }
    
    case DELETE_COUPON: {
      return {
        ...state,
        loader: true,
      };
    }
    default: {
      return state;
    }
  }
}

export default CouponReducer;